import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { FaTrash } from 'react-icons/fa';
import { MdPersonAddAlt1 } from 'react-icons/md';
import { useGrades } from '../grades/Grades';
import { useSeries } from '../series/Series';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#2490AF',
    color: theme.palette.common.white,
    fontSize: 17,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 14,
    fontFamily: 'Roboto',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
  coverImagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
  },
}));

function useBooks() {
  const [books, setBooks] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/books')
      .then((response) => response.json())
      .then((data) => {
        setBooks(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { books, setBooks };
}

export default function CreateBook() {
  const classes = useStyles();
  const { books, setBooks } = useBooks();
  const { series } = useSeries();
  const { grades } = useGrades();
  const [name, setName] = React.useState('');
  const [serie, setSerie] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [coverImage, setCoverImage] = React.useState('');
  const [snackCreateSuccessOpen, setSnackCreateSuccessOpen] =
    React.useState(false);
  const [snackCreateInfoOpen, setSnackCreateInfoOpen] = React.useState(false);
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [selectedBook, setSelectedBook] = React.useState(null);
  const filePickerRef = React.useRef(null);
  const coverImagePreviewRef = React.useRef(null);
  const handleSnackCreateSuccessClose = () => {
    setSnackCreateSuccessOpen(false);
  };

  const handleSnackErrorClose = () => {
    setSnackErrorOpen(false);
  };

  const handleSnackCreateInfoClose = () => {
    setSnackCreateInfoOpen(false);
  };
  const handleCreate = async () => {
    try {
      if (name && coverImage) {
        let formData = new FormData();
        formData.append('name', name);
        formData.append('serie', serie);
        formData.append('grade', grade);
        formData.append('coverImage', coverImage);
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/books',
          {
            method: 'POST',
            body: formData,
          }
        );
        let data = await response.json();
        if (data.success === true) {
          setBooks([...books, data?.data]);
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
        setName('');
        setSerie('');
        setGrade('');
        setCoverImage('');
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleUpdate = async () => {
    try {
      let formData = new FormData();
      formData.append('name', name);
      formData.append('serie', serie);
      formData.append('grade', grade);
      formData.append('coverImage', coverImage);
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/books/${selectedBook?._id}`,
        {
          method: 'PUT',
          body: formData,
        }
      );

      let data = await response.json();
      if (data.success) {
        let index = books.findIndex((g) => g._id === selectedBook?._id);
        books.splice(index, 1, data?.data);
        setBooks(books);
        setSelectedBook(data.data);
        setSnackCreateSuccessOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleDelete = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/books/${selectedBook?._id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      let data = await response.json();
      if (data.success) {
        let booksDeleted = books.filter((g) => g?._id !== selectedBook?._id);
        setBooks(booksDeleted);
        setSnackCreateSuccessOpen(true);

        setName('');
        setSerie('');
        setGrade('');
        setCoverImage('');
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  useEffect(() => {
    if (selectedBook) {
      setName(selectedBook?.name);
      setSerie(selectedBook?.serie);
      setGrade(selectedBook?.grade);
      setCoverImage(selectedBook?.coverImage);
    }
  }, [selectedBook]);
  return (
    <div className={classes.container} style={{ width: '100%' }}>
      <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nombre</StyledTableCell>
              <StyledTableCell>Serie</StyledTableCell>
              <StyledTableCell>Grado</StyledTableCell>
              <StyledTableCell>Fecha De Creación</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {books.map((row) => (
              <StyledTableRow
                onClick={() => setSelectedBook(row)}
                key={row?._id}
              >
                <StyledTableCell>{row?.name}</StyledTableCell>
                <StyledTableCell>{row?.serie?.name}</StyledTableCell>
                <StyledTableCell>{row?.grade?.name}</StyledTableCell>
                <StyledTableCell>{row?.createdAt}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, mediante este formulario usted podrá crear,
          actualizar o eliminar los libros de la plataforma.
        </p>
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Nombre el libro"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="select-serie">Serie del libro</InputLabel>

          <Select
            onChange={(e) => setSerie(e.target.value)}
            value={serie}
            id="select-serie"
          >
            <MenuItem value="" disabled>
              <em>Seleccione una serie</em>
            </MenuItem>
            {series.map((serie) => (
              <MenuItem value={serie._id}>{serie.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="select-grade">Grado del libro</InputLabel>

          <Select
            onChange={(e) => setGrade(e.target.value)}
            value={grade}
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un grado</em>
            </MenuItem>
            {grades.map((grade) => (
              <MenuItem value={grade._id}>{grade.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div
          onClick={() => {
            setCoverImage(null);
            filePickerRef.current.click();
          }}
          className={classes.coverImagePicker}
        >
          {coverImage && (
            <img
              style={{ width: '50px', height: '50px', marginRight: '20px' }}
              ref={coverImagePreviewRef}
              src={coverImage}
              alt="preview"
            />
          )}
          <input
            ref={filePickerRef}
            style={{ display: 'none' }}
            type="file"
            name="coverImage"
            onChange={(e) => {
              setCoverImage(e.target.files[0]);
              const reader = new FileReader();
              reader.onload = (e) => {
                coverImagePreviewRef.current.src = e.target.result;
              };
              reader.readAsDataURL(e.target.files[0]);
            }}
            accept="coverImage/*"
          />
          {coverImage && <p>{coverImage.name}</p>}
          {!coverImage && (
            <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
              Seleccione una imagen para el libro
            </p>
          )}
        </div>
        <Button
          onClick={() => {
            setSelectedBook(null);
            setName('');
            setSerie('');
            setGrade('');
            setCoverImage('');
          }}
        >
          Limpiar
        </Button>
        <div className={classes.formButtonsContainer}>
          <Button variant="contained" color="secondary" onClick={handleDelete}>
            <FaTrash size={15} />
            Eliminar
          </Button>
          <Button variant="contained" onClick={handleUpdate}>
            <AiFillEdit size={15} />
            Actualizar
          </Button>
          <Button onClick={handleCreate} variant="contained" color="primary">
            <MdPersonAddAlt1 size={15} />
            Crear
          </Button>
        </div>
      </form>
      <Snackbar
        open={snackCreateSuccessOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateSuccessClose}
      >
        <Alert onClose={handleSnackCreateSuccessClose} severity="success">
          Se ha creado el libro exitosamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackCreateInfoOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateInfoClose}
      >
        <Alert onClose={handleSnackCreateInfoClose} severity="warning">
          Estimado administrador para crear un libro, por favor llene los campos
          requeridos
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackErrorOpen}
        autoHideDuration={6000}
        onClose={handleSnackErrorClose}
      >
        <Alert onClose={handleSnackErrorClose} severity="error">
          Hubo un error al intentar realizar la operación, por favor intente
          nuevamente
        </Alert>
      </Snackbar>
    </div>
  );
}
